module.exports = __webpack_public_path__ + "static/media/polaroids.675fae0c.jpeg";